(() => {
  const initialise = () => {
    document.querySelectorAll('[data-ox-journal-sample]').forEach((root) => {
      if (root.dataset.layoutReady) return;
      const body = root.querySelector('[data-ox-story-body]');
      if (!body) return;

      const sources = body.querySelector('.ox-journal-image-credit');
      if (sources) sources.classList.add('ox-story-sources');
      root.dataset.layoutReady = 'true';
    });
  };

  const alignSourceAnchor = () => {
    if (!window.location.hash) return;
    const id = decodeURIComponent(window.location.hash.slice(1));
    const target = document.getElementById(id);
    if (!target || !target.closest('[data-ox-story-body]')) return;
    requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
  if (document.readyState === 'complete') alignSourceAnchor();
  else window.addEventListener('load', alignSourceAnchor, { once: true });
  window.addEventListener('hashchange', alignSourceAnchor);
})();
